import './sdo';
const {store, AoflElement, abcmouseTrackerQueue, AppCallService} = aofljs;
/**
 * @summary WiaLauncher
 * @class WiaLauncher
 * @extends {AoflElement}
 */
class WiaLauncher extends AoflElement {
  /**
   * Creates an instance of WiaLauncher.
   * @memberof WiaLauncher
   */
  constructor() {
    super(store);
    let userSession = store.getState().userSession;
    this.isApp = userSession.isApp;
    this.isMobile = userSession.isMobile;
    this.isAndroidPhone = userSession.isAndroidPhone;
    this.host = userSession.host;
    this.showVideoPopupCalled = false;
  }

  /**
   *
   * @readonly
   * @static
   * @memberof WiaLauncher
   */
  static get is() {
    return 'wia-launcher';
  }
  /**
   *
   * @readonly
   * @static
   * @memberof WiaLauncher
   */
  static get properties() {
    return {
      videoPath: String
    };
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  connectedCallback() {
    super.connectedCallback();
    this.mobileVideoElement = this.$.mobileVideo;
    store.commit([
      {
        stateAlias: 'wiaLauncher',
        mutationId: 'updateVideoPath',
        payload: this.videoPath
      }
    ]);
  }

  /**
   *
   * @memberof WiaLauncher
   */
  showVideoPopup() {
    if (this.isApp) {
      this.showAppVideo();
    } else if (this.isMobile) {
      this.showMobileVideo();
    } else {
      this.showDesktopVideo();
    }
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  showAppVideo() {
    let appCallSrc = this.host + this.videoPath;
    AppCallService.showVideo(appCallSrc);
    store.commit([
      {
        stateAlias: 'modals',
        mutationId: 'showModal',
        payload: 'wiaProspect'
      }
    ]);
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  showMobileVideo() {
    if (this.showVideoPopupCalled) return;
    this.showVideoPopupCalled = true;
    this.addExitFullScreenListener();
    this.requestFullscreen();
    this.addVideoEndListener();
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  showDesktopVideo() {
    store.commit([
      {
        stateAlias: 'modals',
        mutationId: 'showModal',
        payload: 'wiaVideo'
      }
    ]);
    this.playVideo();
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  addExitFullScreenListener() {
    this.events = this.events ||
    {
      webkitendfullscreen: {
        listeningElement: this.mobileVideoElement,
        cb: () => {
          this.showVideoPopupCalled && this.handleClose();
        }
      },
      webkitfullscreenchange: {
        listeningElement: document,
        cb: () => {
          this.showVideoPopupCalled && this.fullscreenchangeListener();
        }
      },
      mozfullscreenchange: {
        listeningElement: document,
        cb: () => {
          this.showVideoPopupCalled && this.fullscreenchangeListener();
        }
      },
      fullscreenchange: {
        listeningElement: document,
        cb: () => {
          this.showVideoPopupCalled && this.fullscreenchangeListener();
        }
      },
      MSFullscreenChange: {
        listeningElement: document,
        cb: () => {
          this.showVideoPopupCalled && this.fullscreenchangeListener();
        }
      },
      resize: {
        listeningElement: window,
        cb: () => {
          this.showVideoPopupCalled && !this.isAndroidPhone && this.fullscreenchangeListener();
        }
      }
    };

    for (let event in this.events) {
      if (!this.events.hasOwnProperty(event)) continue;
      let listeningElement = this.events[event].listeningElement;
      let cb = this.events[event].cb;
      listeningElement.addEventListener(event, cb);
    }
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  handleClose() {
    this.removeExitFullScreenListener();
    this.handleTracking();
    this.resetVideo();
    this.showWiaProspectPopup();
    this.forceExitFullscreen();
    this.showVideoPopupCalled = false;
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  handleTracking() {
    let mobileVideoElement = this.mobileVideoElement;
    let elapsedTime = mobileVideoElement.currentTime / mobileVideoElement.duration * 100;
    let roundElapsedTime = Math.round(elapsedTime);
    if (roundElapsedTime === 100) {
      abcmouseTrackerQueue.enqueueEvent({
        url: '@videoComplete',
        kvp: {
          videoName: 'what is abcmouse'
        }
      });
    } else {
      abcmouseTrackerQueue.enqueueEvent({
        url: '@videoClose',
        kvp: {
          videoName: 'what is abcmouse',
          videoProgress: roundElapsedTime.toString()
        }
      });
    }
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  resetVideo() {
    let mobileVideoElement = this.mobileVideoElement;
    mobileVideoElement.pause();
    mobileVideoElement.currentTime = 0;
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  showWiaProspectPopup() {
    store.commit([
      {
        stateAlias: 'modals',
        mutationId: 'showModal',
        payload: 'wiaProspect'
      }
    ]);
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  forceExitFullscreen() {
    let mobileVideoElement = this.mobileVideoElement;
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (mobileVideoElement.webkitExitFullScreen) {
      mobileVideoElement.webkitExitFullScreen();
    }
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  fullscreenchangeListener() {
    let eventElems = ['webkitFullscreenElement', 'mozFullScreenElement', 'msFullscreenElement', 'fullscreenElement'];
    eventElems.forEach((elem) => {
      // If the value is null, this means the browser is not longer in full screen mode.
      if (document[elem] === null) {
        this.handleClose();
      }
    });
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  removeExitFullScreenListener() {
    for (let event in this.events) {
      if (!this.events.hasOwnProperty(event)) continue;
      let listeningElement = this.events[event].listeningElement;
      let cb = this.events[event].cb;
      listeningElement.removeEventListener(event, cb);
    }
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  requestFullscreen() {
    let mobileVideoElement = this.mobileVideoElement;
    if (mobileVideoElement.requestFullscreen) {
      mobileVideoElement.requestFullscreen();
    } else if (mobileVideoElement.mozRequestFullScreen) {
      mobileVideoElement.mozRequestFullScreen();
    } else if (mobileVideoElement.webkitRequestFullscreen) {
      mobileVideoElement.webkitRequestFullscreen();
    } else if (mobileVideoElement.webkitEnterFullScreen) {
      mobileVideoElement.webkitEnterFullScreen();
    } else if (mobileVideoElement.msRequestFullscreen) {
      mobileVideoElement.msRequestFullscreen();
    }
    mobileVideoElement.play();
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  addVideoEndListener() {
    let listener = () => {
      this.handleClose();
      this.mobileVideoElement.removeEventListener('ended', listener);
    };
    this.mobileVideoElement.addEventListener('ended', listener);
  }

  /**
   *
   *
   * @memberof WiaLauncher
   */
  playVideo() {
    let interval = setInterval(() => {
      let video = this.getVideoElement();

      if (video) {
        video.play();
        clearInterval(interval);
      }
    }, 100);
  }

  /**
   *
   *
   * @return {*} mobileVideoElement
   * @memberof WiaLauncher
   */
  getVideoElement() {
    let wiaVideo = document.getElementById('wiaVideo');
    let aoflDrawer = wiaVideo ? wiaVideo.shadowRoot.querySelector('aofl-drawer') : null;
    let abcmouseVideo = aoflDrawer ? aoflDrawer.querySelector('abcmouse-video') : null;
    let video = abcmouseVideo ? abcmouseVideo.shadowRoot.getElementById('video') : null;
    return video;
  }
}

window.customElements.define(WiaLauncher.is, WiaLauncher);



// WEBPACK FOOTER //
// ./home/en-US/js/wia-launcher/wia-launcher.js